import styled from 'styled-components';

const RadioContainer = styled.div`
  display: flex;

  label {
    padding-right: 1rem;
  }
`;

export default RadioContainer;
